export const COLOR_HEX = {
  negro: '#111827', black: '#111827', blanco: '#F8FAFC', white: '#F8FAFC', azul: '#1D4ED8', blue: '#1D4ED8',
  verde: '#166534', green: '#166534', rojo: '#DC2626', red: '#DC2626', morado: '#7C3AED', lila: '#C4B5FD', purple: '#7C3AED',
  dorado: '#D4AF37', gold: '#D4AF37', plata: '#CBD5E1', gris: '#6B7280', rosa: '#F9A8D4', amarillo: '#FACC15', naranja: '#FB8500',
};
export const colorHex = (name) => COLOR_HEX[String(name || '').toLowerCase().split(' ')[0]] || '#64748B';

export const rateOf = (mall) => {
  const r = mall?.rates || {};
  return Number(r.use === 'paralelo' ? r.paralelo || r.bcv : r.bcv) || 0;
};

export const fmtPrice = (usd, currency, rate) => (currency === 'BS' && rate
  ? `Bs. ${(usd * rate).toLocaleString('es-VE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`
  : `$${Number(usd || 0).toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 0 })}`);

const FREQ = { '7': ['semanal', 'semanales'], '14': ['quincenal', 'quincenales'], mensual: ['mensual', 'mensuales'] };

export const creditPlan = (price, mall, tradeIn = 0, own = null) => {
  if (own && own.installments) {
    const n = Number(own.installments) || 1;
    const down = Number(own.down_payment) || 0;
    const amount = (price - down) / n;
    const f = FREQ[own.frequency] || FREQ['14'];
    const d = { n, amount, frequency: own.frequency || '14', label: f[1] };
    return { down, financed: price - down, semanal: d, quincenal: d, mensual: d, default: d, own: true, freqLabel: f[0] };
  }
  const c = mall?.credit || {};
  const dp = Math.max(0, price * (Number(c.down_payment_percent ?? 30) / 100) - tradeIn);
  const financed = Math.max(0, (price - price * (Number(c.down_payment_percent ?? 30) / 100)) * (1 + Number(c.interest_percent || 0) / 100));
  const t = c.terms || {};
  return {
    down: Math.round(dp * 100) / 100, financed,
    semanal: { n: t.semanal || 8, amount: financed / (t.semanal || 8), frequency: '7' },
    quincenal: { n: t.quincenal || 4, amount: financed / (t.quincenal || 4), frequency: '14' },
    mensual: { n: t.mensual || 3, amount: financed / (t.mensual || 3), frequency: 'mensual' },
    get default() { return { ...this.semanal, label: 'semanales' }; },
  };
};

export const photoUrl = (p) => {
  const f = p?.photos?.[0];
  if (!f) return null;
  return f.startsWith('http') ? f : `${process.env.REACT_APP_BACKEND_URL}/api/public/files/${f.replace('/api/files/', '')}`;
};

export const isAccessory = (p) => /accesor|forro|cargador|protector|aud[ií]fono|cable|case/i.test(`${p.category} ${p.name}`);
